import { render } from "./UnitsSearchFilters.vue?vue&type=template&id=48713b68"
import script from "./UnitsSearchFilters.vue?vue&type=script&lang=js"
export * from "./UnitsSearchFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__